import { StackAtom } from 'components/atoms/Stack.atom'
import type { ShipmentPreparationPallet } from 'types/shipment/model'
import { ShipmentPalletCardOrganism } from './ShipmentPalletCard'

interface ShipmentPalletsOrganismProps {
  pallets: ShipmentPreparationPallet[]
}

export const ShipmentPalletsOrganism = (
  props: ShipmentPalletsOrganismProps
) => {
  const { pallets } = props

  return (
    <StackAtom $direction="column" $gap={16}>
      {pallets.map((palletData, index) => (
        <ShipmentPalletCardOrganism
          key={palletData.container}
          palletNumber={index + 1}
          totalPallets={pallets.length}
          {...palletData}
        />
      ))}
    </StackAtom>
  )
}
